var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalAlign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 16,
      height: 17
    },
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02111 5.27902V0.111098H8.04367V5.27902L10.7862 3.0016L11.5091 3.60195L7.53239 6.9043L3.55566 3.60195L4.27861 3.0016L7.02111 5.27902Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09021 11.8321V17H7.06766V11.8321L4.32516 14.1095L3.60221 13.5091L7.57894 10.2068L11.5557 13.5091L10.8327 14.1095L8.09021 11.8321Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7.90796,
    width: 1.77778,
    height: 16,
    transform: "rotate(90 16 7.90796)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalAlign);
export default __webpack_public_path__ + "static/media/vertical_align.7aa980fd6448af00409b86417bf6ff3d.svg";
export { ForwardRef as ReactComponent };